const HTML_TYPE = "wix-draft-plugin-html";
export {
  HTML_TYPE
};
//# sourceMappingURL=types.js.map
